import React from "react";
import "../Styles/Course-card.css";

const CourseCard = ({ title, Cards ,content}) => {
  return (
    <div className="course-card-container">
      <h1 className="course-card-title">{title}</h1>
      {content.length>0 && <p className="course-card-content">{content}</p>}
      <div className="course-card-cards">
        {Cards.map((item, index) => {
          return (
            <div key={index} className="course-card-with-hr">
              <div className="course-card">
                <img src={item.icon} alt="icon" />
                <h2>{item.heading}</h2>
                <p>{item.content}</p>
              </div>
              {Cards[index+ 1] && <hr />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CourseCard;
